/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'company-manage': {
    width: 24,
    height: 24,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M0 102.4V1024h665.6V102.4L512 0zm384 808.96H76.8V819.2l307.2-5.12zm0-204.8l-307.2 5.12v-92.16L384 599.04zm0-220.16L76.8 506.88v-92.16L384 378.88zm0-225.28L76.8 302.08V204.8L384 143.36zM921.6 921.6V102.4L768 0h-76.8L768 51.2V1024h256V921.6H921.6z"/>'
  }
})
